import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62d01ee4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d01ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d01ee4')) {
      api.createRecord('62d01ee4', component.options)
    } else {
      api.reload('62d01ee4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62d01ee4&scoped=true", function () {
      api.rerender('62d01ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamTree/index.vue"
export default component.exports